import { useQuery } from "react-query";
import { getEmployeesBy } from "../../../../../actions/Employees/index";

const useSearchEmployees = ({ filteredValue }) => {
  return useQuery(["GetEmployeesBy", filteredValue], getEmployeesBy, {
    refetchOnWindowFocus: false,
    enabled: false,
  });
};

export default useSearchEmployees;
